import Amplify, { Auth } from 'aws-amplify';
import axios from 'axios';
import { chineseAuth, server } from './server';
// import informSlack from '../util/informSlack';

const env = process.env.REACT_APP_ENV;

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_REGION,

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_USERPOOLID,

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_USERPOOLCLIENTID,
  },
});

export function signout() {
  // localStorage.removeItem('px_auth');
  // localStorage.removeItem('px_pagination');
  // localStorage.removeItem('alternate_name');
  // localStorage.removeItem('alternate_email');
  // localStorage.removeItem('alternate_phone');
  // localStorage.removeItem('px_uid');
  // localStorage.removeItem('px_t');
  // localStorage.removeItem('px_refreshing');
  // localStorage.removeItem('px_stop');
  // localStorage.pxBuilding = '[]';
  // localStorage[
  //   'CognitoIdentityServiceProvider.5oce0evqf0mfifuuhabgfjjjuq.c5cc844d-d421-4b1f-bba3-6498de572131.accessToken'
  // ] = null;
  // localStorage[
  //   'CognitoIdentityServiceProvider.5oce0evqf0mfifuuhabgfjjjuq.c5cc844d-d421-4b1f-bba3-6498de572131.refreshToken'
  // ] = null;
  // localStorage[
  //   'CognitoIdentityServiceProvider.5oce0evqf0mfifuuhabgfjjjuq.LastAuthUser'
  // ] = null;
  // localStorage[
  //   'CognitoIdentityServiceProvider.5oce0evqf0mfifuuhabgfjjjuq.cb597796-565d-45cb-93c3-c98db54475e0.clockDrift'
  // ] = null;
  // localStorage[
  //   'CognitoIdentityServiceProvider.5oce0evqf0mfifuuhabgfjjjuq.cb597796-565d-45cb-93c3-c98db54475e0.idToken'
  // ] = null;
  // localStorage[
  //   'CognitoIdentityServiceProvider.5oce0evqf0mfifuuhabgfjjjuq.cb597796-565d-45cb-93c3-c98db54475e0.userData'
  // ] = null;
  // localStorage.px_stop = true;
  return new Promise((resolve, reject) => {
    // if (env && env.includes('cn')) {
    //   if (window.location.pathname === '/' || window.location.pathname.includes('/login')) {
    //     reject();
    //   } else {
    //     window.location.href = '/';
    //   }
    // } else {
    Auth.signOut()
      .then(() => resolve())
      .catch(err => resolve(err));
    // }
  });
}

// function iterate() {
//   let time = localStorage.px_t;
//   if (time) {
//     time = parseInt(time, 10);
//     time = (time - 60) * 1000;
//   }
//   setTimeout(function () {
//     let stop;
//     if (localStorage.px_stop) {
//       try {
//         stop = JSON.parse(localStorage.px_stop);
//       } catch (e) {
//         // informSlack(e);
//       }
//     }
//     if (stop) window.location.href = '/';
//     else refreshToken();
//   }, time);
// }

export function refreshToken() {
  return new Promise((resolve, reject) => {
    // if (env && env.includes('cn') && window.location.pathname !== '/') {
    //   localStorage.px_refreshing = true;
    //   if (localStorage.px_auth) {
    //     let refreshTkn = null;
    //     try {
    //       refreshTkn = JSON.parse(atob(localStorage.px_auth)).refresh_token;
    //     } catch (e) {
    //       informSlack(e);
    //     }
    //     axios
    //       .post(
    //         `${chineseAuth}/api/auth/refresh`,
    //         {
    //           refresh_token: refreshTkn,
    //         },
    //         { refresh_token: refreshTkn },
    //       )
    //       .then(response => {
    //         if (response && response.data) {
    //           localStorage.px_t = response.data.login_details.expires_in;
    //           localStorage.px_uid = response.data.user_details.uuid;
    //           try {
    //             localStorage.px_auth = btoa(JSON.stringify(response.data.login_details),);
    //           } catch (e) {
    //             informSlack(e);
    //           }
    //           localStorage.px_refreshing = false;
    //           iterate();
    //           resolve(response.data);
    //         } else signout();
    //       })
    //       .catch(error =>
    //         signout()
    //           .then(() => reject(error))
    //           .catch(() => reject(error)),);
    //   } else {
    //     signout()
    //       .then(() => reject())
    //       .catch(() => reject());
    //   }
    // } else
    reject();
  });
}

export function signin(username, password) {
  const nonsensitiveUsername = username.toLowerCase();
  const nonsensitivepassword = password.trim();
  return new Promise((resolve, reject) => {
    // if (env && env.includes('cn')) {
    //   axios
    //     .post(`${chineseAuth}/api/auth/login`, {
    //       username: nonsensitiveUsername,
    //       password: nonsensitivepassword,
    //     })
    //     .then(user => {
    //       if (user && user.data) {
    //         localStorage.px_t = user.data.login_details.expires_in;
    //         localStorage.px_stop = false;
    //         localStorage.px_refreshing = false;
    //         localStorage.px_uid = user.data.user_details.uuid;
    //         iterate(localStorage.px_t);
    //         resolve(user);
    //       } else signout();
    //     })
    //     .catch(err => reject(err));
    // } else {
    Auth.signIn(nonsensitiveUsername, nonsensitivepassword)
      .then(user => resolve(user))
      .catch(err => reject(err));
    // }
  });
}

export function changePassword(oldPass, newPass) {
  return new Promise((resolve, reject) => {
    // if (env && env.includes('cn')) {
    //   let token = JSON.parse(atob(localStorage.px_auth)).access_token;
    //   axios
    //     .post(
    //       `${chineseAuth}/api/user/update_password`,
    //       {
    //         old_password: oldPass,
    //         new_password: newPass,
    //       },
    //       {
    //         headers: { Authorization: `Bearer ${token}` },
    //       },
    //     )
    //     .then(user => resolve(user))
    //     .catch(err => reject(err));
    // } else {
    Auth.currentAuthenticatedUser()
      .then(user => Auth.changePassword(user, oldPass, newPass))
      .then(data => resolve(data))
      .catch(err => reject(err));
    // }
  });
}

export function sendEmail(email) {
  const nonsensitiveemail = email.toLowerCase();
  return new Promise((resolve, reject) => {

    if (env && env.includes('cn')) {
      axios
        .post(`${chineseAuth}/api/user/generate_code`, {
          email: nonsensitiveemail,
        })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    } else {
      Auth.forgotPassword(nonsensitiveemail)
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    }
  });
}

export function resetPassword(email, resetCode, newPassword) {
  return new Promise((resolve, reject) => {
    // if (env && env.includes('cn')) {
    //   axios
    //     .post(`${chineseAuth}/api/user/forgot_password`, {
    //       email,
    //       reset_code: resetCode,
    //       new_password: newPassword,
    //     })
    //     .then(response => resolve(response))
    //     .catch(err => reject(err));
    // } else {
    Auth.forgotPasswordSubmit(email, resetCode, newPassword)
      .then(response => resolve(response))
      .catch(error => reject(error));
    // }
  });
}

export function forceResetPassword(email, temporaryPassword, newPassword) {
  return new Promise((resolve, reject) => {
    ////////////////////////////////////////////////////////////
    let user = localStorage.getItem('tempUser') ? JSON.parse(localStorage.getItem('tempUser')) : null;
    // Auth.signIn(email, temporaryPassword)
    //   .then(user => {
    //     Auth.completeNewPassword(user, newPassword, {})
    //       .then(response => {resolve(response)})
    //       .catch(err => reject(err));
    //   })
    //   .catch(err => reject(err));

    ///////////////////////////////////////////////////////////////

    Auth.completeNewPassword(user, newPassword, {})
      .then(response => { resolve(response) })
      .catch(err => reject(err));
  });
}

// export function getProfile(username) {
//   return new Promise((resolve, reject) => {
//     axios
//       .get(`${server}/entity/user/${username}?include_mailrooms=true`)
//       .then(response => resolve(response.data))
//       .catch(err => reject(err));
//   });
// }

export function getRoles() {
  return new Promise((resolve, reject) => {
    axios
      .get(`${server}/entity/roles`)
      .then(response => resolve(response.data))
      .catch(err => reject(err));
  });
}

export function confirmUser(uuid) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${server}/entity/user/${uuid}`, { confirm_user: true })
      .then(response => resolve(response))
      .catch(error => reject(error));
  });
}

export function getUserData() {
  return new Promise((resolve, reject) => {
    axios.get(`${process.env.REACT_APP_MOCK_BASE_URL}/entity/user/${window.atob(localStorage.getItem('user_uuid'))}`)
      .then(response => {
        resolve(response)
      })
      .catch(error => reject(error));
  });
}
